import React from 'react';
import cn from 'classnames';
import { useImage } from '../ImageContext';
import styles from './ToastMessage.module.scss';

export type ToastMessageProps = {
  title: string;
  message: string;
  type: 'success' | 'error';
  onClose?: () => void;
};

const ToastMessage: React.FC<ToastMessageProps> = ({
  type,
  title,
  message,
  onClose,
}) => {
  const errorImage = useImage('error');
  const successImage = useImage('success');
  const closeImage = useImage('dark-cross');
  const rootClass = cn(styles.container, {
    [styles.container_error]: type === 'error',
  });

  const { src: iconSrc, onError: iconError } =
    type === 'error' ? errorImage : successImage;

  return (
    <div className={rootClass}>
      <img src={iconSrc} onError={iconError} className={styles.icon} alt="" />
      <div className={styles.info}>
        <div className={styles.info__title}>{title}</div>
        <div className={styles.info__message}>{message}</div>
      </div>
      <img
        src={closeImage.src}
        onError={closeImage.onError}
        className={styles.close}
        alt=""
        onClick={onClose}
      />
    </div>
  );
};

export default ToastMessage;
